module.exports = __webpack_public_path__ + "static/scale-model-of-botanic-gardens-in-baton-rouge-louisiana-892f669f328d03f9535370bfd7bb6b13.png";